import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'gatsby'
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

import trads from '../../intl/trads.json'

import LinkIcon from '../linkIcon'
import Image from '../image'

import transformLink from '../../utils/transformLink'

const InfosCard = ({blog, fromAlgolia = false}) => {
  const lang = useSelector(state => state.lang)
  const url = transformLink(blog, false, true).url

  blog = blog.fields ? blog.fields : blog
  let chapo = blog.chapo.raw ? blog.chapo.raw : blog.chapo

  chapo = (fromAlgolia) ? chapo : documentToPlainTextString(JSON.parse(chapo.raw))

  return (
    <Link to={url} className="card page-card">
      { blog.mainImage ?
        <Image
        image={blog.mainImage}
        width={305}
        height={202}
        classes="w-full card__img"
        sizes={{"415": [367, 243], "767": [720, 476], "1023": [460, 305], "1279": [400, 265] }}
      />
      : <div className="card__empty card__empty--page">
          <img src="/img/logo.svg" alt="Terega Solutions" />
        </div>
      }
      <div className="page-card__content">
        <div className="mb-5">
          {blog.mainTag && blog.mainTag !== 'Default' && blog.mainTag !== 'Institutionnel' &&
            <p className="text-label mb-2 text-purple">{blog.mainTag}</p>
          }
          <p className="card__title page-card__title">{blog.title}</p>
          {chapo &&
            <p className="page-card__chapo mt-4">{(chapo.length > 200) ? `${chapo.slice(0, 200)}...` : chapo}</p>
          }
        </div>

        <LinkIcon text={trads[lang].newsroom.blogRead} />
      </div>
    </Link>
  )
}

export default InfosCard